import AnimationController from './animation';

class HeightController {

	animation;

	subscribers = [];

	height = 0;
	changed = false;

	initialize() {
		this.animation = AnimationController.set({
			update: this.#update,
			render: this.#render
		});
	}

	#update = () => {
		if (this.changed && !isNaN(parseFloat(this.height))) {
			for (const subscriber of this.subscribers) {
				if (subscriber) subscriber();
			}
			this.changed = false;
			return true;
		}
	}

	#render = () => {
		document.body.style.height = `${this.height}px`;
	}

	adjust(height) {
		if (height !== this.height) {
			this.height = height;
			this.changed = true;
		}
	}

	// remove any adjustments from height controller

	removeStyles() {
		this.height = null;
		document.body.style.height = '';
	}

	// add / remove subscribers

	add(fn) {
		this.subscribers.push(fn);
	}

	remove(fn) {
		for (let i = 0, l = this.subscribers.length; i < l; ++i) {
			if (fn === this.subscribers[i]) {
				delete this.subscribers[i];
				break;
			}
		}
	}

}

export default new HeightController();
